import { cn } from '../../lib/utils';

const SITE_LOGO_WEBP = `${process.env.PUBLIC_URL}/sitelogo.webp`;
const SITE_LOGO_PNG = `${process.env.PUBLIC_URL}/sitelogo.png`;

const SITE_LOGO_WIDTH = 384;
const SITE_LOGO_HEIGHT = 222;

type SiteLogoProps = {
  alt?: string;
  className?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
};

export function SiteLogo({
  alt = 'William Wilder Nash logo',
  className,
  fetchPriority = 'auto',
}: SiteLogoProps) {
  return (
    <picture>
      <source srcSet={SITE_LOGO_WEBP} type="image/webp" />
      <img
        src={SITE_LOGO_PNG}
        alt={alt}
        width={SITE_LOGO_WIDTH}
        height={SITE_LOGO_HEIGHT}
        decoding="async"
        fetchPriority={fetchPriority}
        className={cn('object-contain filter invert brightness-200', className)}
      />
    </picture>
  );
}
